import ReactGA from "react-ga4";
import { usePathname } from "next/navigation";
import { useEffect } from "react";

const GoogleTracker = () => {
  const id = "GTM-MZLGH22";
  const path = usePathname();

  // track all page views, and page changes

  ReactGA.initialize([
    {
      trackingId: id,
      gaOptions: {
        siteSpeedSampleRate: 100,
      },
    },
  ]);

  useEffect(() => {
    const pageTitle = document.title;
    ReactGA.send({ hitType: "pageview", page: path, title: pageTitle });
  }, [path]);

  return <></>;
};

export default GoogleTracker;
